export default "__VITE_ASSET__OucE9NFn__"